import { render, staticRenderFns } from "./VSwiper.vue?vue&type=template&id=a934f266&scoped=true"
import script from "./VSwiper.vue?vue&type=script&lang=ts"
export * from "./VSwiper.vue?vue&type=script&lang=ts"
import style0 from "./VSwiper.vue?vue&type=style&index=0&id=a934f266&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a934f266",
  null
  
)

export default component.exports